// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__3y1_l","footer":"ChangeClinic_footer___KplO"};